module.exports = __webpack_public_path__ + "static/media/admin_canvas_collar_icon.88d4a73e.svg";